// extracted by mini-css-extract-plugin
module.exports = {"Section":"__04-BlogList_Section__BM9ci","BlogList":"__04-BlogList_BlogList__sELwn"};